<template>
  <div></div>
</template>

<script>
  export default {
    name: "separator",
  };
</script>

<style scoped>

  div {
    @apply w-full bg-grey-bg h-2;
  }

</style>

